import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  token: null,
  datas: null,
  marketData: null,
  filters: {},
};

export const authSlice = createSlice({
  name: "Rubio_store",
  initialState,
  reducers: {
    setDatas: (state, action) => {
      state.datas = action.payload.datas;
    },
    updateMarketDatas: (state, action) => {
      state.marketData = { ...state.marketData, ...action.payload.marketData };
    },
    setFilters: (state, action) => {
      state.filters = action.payload.filters;
    },
    setLogin: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      localStorage.setItem("token", action.payload.token);
    },
    setLogout: (state) => {
      state.user = null;
      state.token = null;
      localStorage.removeItem("token");
    },
  },
});

export const { setDatas, updateMarketDatas, setFilters, setLogin, setLogout } =
  authSlice.actions;
export default authSlice.reducer;
